import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.808 2.425a2 2 0 0 0-2.85 2.425L7.934 16 3.958 27.152a2 2 0 0 0 2.85 2.423L27.922 17.75l.002-.002a2 2 0 0 0 0-3.497l-.002-.001L6.814 2.428zm20.14 13.573.49-.873-.485.875-.004.003L5.84 27.825 9.701 17H17a1 1 0 1 0 0-2H9.7L5.842 4.177v-.002z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconPaperPlaneRight = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconPaperPlaneRight);
export default Memo;
